import {
  showButtonDisabledWithSpinner,
  clearButtonDisabledWithSpinner,
  showLinkDisabledWithSpinner
} from '../helpers/showDisabledWithSpinner';
import { debounce } from './shared';

$('body').on(
  'click',
  '.js-account-default-payment-method-cancel',
  function (event) {
    var section = $(this).data('profile-section');
    event.preventDefault();
    $.ajax({
      url:
        '/umbraco/Surface/AccountProfileSurface/CancelAccountDefaultPaymentMethodOptionForm?profileFormSection=' +
        section,
      type: 'POST',
      contentType: 'application/json',
      error: function error(data) {
        console.log('There was a problem updating profile form');
        console.log(data);
      },
      success: function success(data) {
        var elementToReplace = '#profile' + section + 'Form';
        $(elementToReplace).html(data);
      }
    });
  }
);

$('body').on('click', '.js-account-delivery-address-cancel', function (event) {
  event.preventDefault();
  $.ajax({
    url:
      '/umbraco/Surface/AccountProfileSurface/CancelAccountDeliveryAddressForm',
    type: 'POST',
    contentType: 'application/json',
    error: function (data) {
      console.log(data);
    },
    success: function (data) {
      $('#profileDeliveryAddressForm').html(data);
    }
  });
});

$('body').on(
  'click',
  '.js-account-delivery-address-cancel-international',
  function (event) {
    event.preventDefault();
    $.ajax({
      url:
        '/umbraco/Surface/AccountProfileSurface/CancelAccountDeliveryAddressFormInternational',
      type: 'POST',
      contentType: 'application/json',
      error: function (data) {
        console.log(data);
      },
      success: function (data) {
        $('#profileDeliveryAddressForm').html(data);
      }
    });
  }
);

$('body').on('click', '.js-account-default-delivery-cancel', function (event) {
  event.preventDefault();
  $.ajax({
    url:
      '/umbraco/Surface/AccountProfileSurface/CancelAccountDefaultDeliveryForm',
    type: 'POST',
    contentType: 'application/json',
    error: function (data) {
      console.log(data);
    },
    success: function (data) {
      $('#profileDeliveryOptionForm').html(data);
    }
  });
});

// Submit search form on order history on button click
$('body').on('click', '.js-order-history-search', function () {
  $(this).closest('form').submit();
});

// Delete the clear search button

$('body').on(
  'keyup',
  '.js-search-order-input',
  debounce(function () {
    if ($(this).val() == '') {
      $(this)
        .closest('.input-group')
        .find('.clear-search-btn')
        .addClass('clear-search-btn--hidden');
    } else {
      $(this)
        .closest('.input-group')
        .find('.clear-search-btn')
        .removeClass('clear-search-btn--hidden');
    }
  })
);

$('.js-profile-change-btn').click(function () {
  $(this)
    .closest('.button-with-loader')
    .find('.loader')
    .removeClass('loader--hidden');
});

function loadData(index, operation, addressId) {
  var formName = '#profileBTSCalendarEditForm-' + addressId;
  var elementsFromDate = $(formName).find("input[name$='FromDate']");
  var elementsToDate = $(formName).find("input[name$='ToDate']");
  var calendarPeriods = [];
  if (elementsFromDate.length > 0) {
    $.each(elementsFromDate, function (index, item) {
      calendarPeriods.push({
        fromDate: item.value,
        toDate: elementsToDate[index].value
      });
    });
  }

  var data = JSON.stringify({
    index: index,
    operation: operation,
    addressId: addressId,
    calendarPeriods: calendarPeriods
  });
  var elementName = '#btsCalendarEditForm-' + addressId;
  $(elementName).html(
    '<div class="mt-3 mb-5"><div class="loader-mask "><div class="loader-mask__title">Adding calendar entries...</div><div class="loader loader--small"></div></div></div>'
  );
  $.ajax({
    url: '/umbraco/Surface/AccountProfileSurface/UpdateAccountBTSPeriods',
    data: data,
    type: 'POST',
    contentType: 'application/json',
    error: function (data) {
      console.log(data);
    },
    success: function (data) {
      $(elementName).html(data);
    }
  });
}

$('body').on('click', '.js-account-bts-calendar-cancel', function (event) {
  var elementLoader = $(this).find('.js-accd-loader .loader');
  $(elementLoader).removeClass('loader--hidden');
  var addressId = event.currentTarget.getAttribute('value');
  event.preventDefault();
  $.ajax({
    url: `/umbraco/Surface/AccountProfileSurface/CancelAccountBTSCalendarForm?addressId=${addressId}`,
    type: 'POST',
    contentType: 'application/json',
    error: function (data) {
      console.log(data);
    },
    success: function (data) {
      $(`#btsCalendarForm-${addressId}`).html(data);
    }
  });
});

$('#btsCalendar').delegate('.calendar-add-period', 'click', function (el) {
  var index = -1;
  if (el.currentTarget.id != '-1') {
    index = el.currentTarget.id.split('-')[0];
  }
  var addressId = el.currentTarget.getAttribute('value');
  loadData(index, 'add', addressId);
});

$('#btsCalendar').delegate('.calendar-delete-period', 'click', function (el) {
  var index = -1;
  if (el.currentTarget.id != '-1') {
    index = el.currentTarget.id.split('-')[0];
  }
  var addressId = el.currentTarget.getAttribute('value');
  loadData(index, 'delete', addressId);
});

$(document).ready(function () {
  if (window.location.search === '?calendar=') {
    $('html, body').animate(
      {
        scrollTop: $('#calendar').offset().top
      },
      500
    );
  }
});

// login/register form
// add disable behaviour on sign in *button*
$('.login-form').on('submit', function () {
  showButtonDisabledWithSpinner();

  // remove button disabled if form is invalid
  window.setTimeout(() => {
    if ($('.field-validation-error').length) {
      clearButtonDisabledWithSpinner();
    }
  }, 0);
});

// mimic disable behaviour on create an account/register *link*
$('.js-link').on('click', function () {
  showLinkDisabledWithSpinner();
});
// end login form

// register form
$('.new-user-form').on('submit', function () {
  showButtonDisabledWithSpinner();

  window.setTimeout(() => {
    if ($('.field-validation-error').length) {
      clearButtonDisabledWithSpinner();
    }
  }, 0);
});
// end register form

// password reset form
$('.password-reset-form').on('submit', function () {
  showButtonDisabledWithSpinner();

  window.setTimeout(() => {
    if ($('.field-validation-error').length) {
      clearButtonDisabledWithSpinner();
    }
  }, 0);
});
